<div>
    <app-content-container [content_template]="page_content" [is_loading]="is_loading" [loading_text]="loading_text"
                           [custom_class]="'no-padding'"></app-content-container>
</div>
<ng-template #page_content>
    <div *ngIf="is_loading">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>

    <main class="tiles padding">
        <a routerLink="/user" class="link-clear" *ngIf="is_admin">
            <app-icon-tile title="Benutzer" icon="fas fa-users-cog"></app-icon-tile>
        </a>
        <a routerLink="/admin/games" class="link-clear" *ngIf="is_admin || is_contract_admin">
            <app-icon-tile title="Games" icon="fas fa-solid fa-gamepad"></app-icon-tile>
        </a>
        <a routerLink="/admin/ifa" class="link-clear" *ngIf="is_admin">
            <app-icon-tile title="IFA" icon="fas fa-users-cog"></app-icon-tile>
        </a>
    </main>
</ng-template>

